module.exports = __webpack_public_path__ + "media/images/lb/505-9a12da52a06dca5cd4508c4c23e0a8e9.svg";